/* 15 Oct tidy-up (Claude). Delete this file's <script> line in snippets/meta-tags.liquid to undo. */
(function () {
  var css = document.createElement('style');
  css.textContent =
    '.sww-subtitle{margin:-4px 0 10px;font-size:15px;line-height:1.4;opacity:.75}' +
    '.product__description.sww-clamp{max-height:520px;overflow:hidden;position:relative}' +
    '.product__description.sww-clamp:after{content:"";position:absolute;left:0;right:0;bottom:0;height:120px;background:linear-gradient(rgba(245,240,232,0),rgb(245,240,232))}' +
    '.sww-more{display:block;width:100%;min-height:46px;margin:8px 0 20px;border:1px solid #1f4d3a;border-radius:999px;background:transparent;color:#1f4d3a;font:inherit;font-weight:600;cursor:pointer;order:6}' +
    '.product__info>.product__blocks>*{min-width:0;max-width:100%}' +
    '.vtl-tb-main-widget,.vtl-tb-main-widget__badges{max-width:100%}.vtl-tb-main-widget__badges{flex-wrap:wrap;justify-content:center}';
  document.head.appendChild(css);
  /* 1. Product title: keep the main name big, move the extra detail to a smaller line underneath.
        The full words stay on the page (good for Google), it just reads tidier. */
  function splitTitle() {
    var h = document.querySelector('.product__info .product__title');
    if (!h || h.dataset.swwSplit) return;
    var full = h.textContent.trim();
    var parts = full.split(/\s+[—–|]\s+|\s+-\s+/);
    if (parts.length < 2) return;
    var main = parts.shift();
    var rest = parts.filter(function (p) {
      return !/SniffWaggleNWalk/i.test(p) && !/^[A-Z][A-Za-z]+™$/.test(p.trim());
    }).join(' · ');
    h.dataset.swwSplit = '1';
    h.textContent = main;
    if (rest) {
      var sub = document.createElement('p');
      sub.className = 'sww-subtitle';
      sub.textContent = rest;
      h.insertAdjacentElement('afterend', sub);
    }
  }

  /* 2. Phones: show the start of long descriptions with a "Read full description" button */
  function readMore() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var d = document.querySelector('.product__description');
    if (!d || d.dataset.swwMore || d.dataset.swwStructured || d.scrollHeight < 900) return;
    d.dataset.swwMore = '1';
    d.classList.add('sww-clamp');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sww-more';
    b.textContent = 'Read full description';
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () {
      var open = d.classList.toggle('sww-clamp') === false;
      b.textContent = open ? 'Show less' : 'Read full description';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) d.scrollIntoView({ block: 'start' });
    });
    d.insertAdjacentElement('afterend', b);
  }

  function run() { try { splitTitle(); } catch (e) {} try { readMore(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
